export default __webpack_public_path__ + "static/media/BaseballBat_3.1ed0e662.png";